import { Circle } from 'better-react-spinkit';
import React from 'react';
import { Container } from './styles';

export default function Loading() {
 return (
    <Container>
        <Circle/>
    </Container>
 );
}